!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('app/helper/logging.se',[
      'toasties',
      'app/helper/copy',
      'app/app.utils',
      'app/helper/cookies'
    ], factory)
  }
}(
  /**
   * @typedef SeLToastyFn
   * @param {string} title
   * @param {string} message
   * @param {string} buttonLabel
   * @param {function()} [callbackFn] callback for button pressed
   * @param {object} [params]
   * @returns void
   */

  /**
   * @typedef SeLoggingInst
   * @property {object} ERROR_TYPE error types
   * @property {function(...*):void} remoteLog sends all arguments console.log like to backend
   * @property {function(errorObject: object, params: [object]):void} error calls "handleError" with a default redbox
   * @property {SeLToastyFn} error_plain
   * @property {SeLToastyFn} warn
   * @property {SeLToastyFn} success
   * @property {function ():void} dismissAll
   * @property {function (delayReloadMs: number):void} tryReloadingPage
   * @property {function (eventType: string, callbackFn: function()):void} on
   * @property {function (evenType: string, callbackFn: function()): void} off
   * @property {function (object)} setInfo
   */

  /**
   * @param toasties
   * @param copy
   * @param UTILS
   * @param {seCookies} cookies
   * @return {SeLoggingInst}
   * @constructor
   */
  function SeLogging (toasties, copy, UTILS, cookies) {

    var LOG_LABEL = 'LOG'

    var
      SE = window.SE,
      ENV = SE.APPENV,
      UISID = cookies.getUISID()

    var PAGE_IS_UNLOADING
    window.addEventListener('beforeunload', function () {
      PAGE_IS_UNLOADING = true
    })

    var
      DEBUG_MODE = !!SE.IS_DEBUG,
      EXTERNAL_LOG_URIS = SE.LOG_ERRORS_URL && SE.LOG_ERRORS_URL.split(',').map(function(v){ return v.trim()}),
      CACHE_LOGS = false //!!SE.IS_DEBUG

    var EXTERNAL_LOG_RESEND_LOG_DELAY_MS = 10000

    var maxNrOfErrorToastiesToShow = 1

    var sentLogIds = {},  // log_id alpanum : int timestamp
      externalLogQueue = [],
      externalLogDelay,    // timeout ref
      state_isLoggingToExternalLog = false;

    // console polyfill
    // Console-polyfill. MIT license; https://github.com/paulmillr/console-polyfill; Make it safe to do console.log() always.
    (function (global) {
      'use strict'
      if (!global.console) {
        global.console = {}
      }
      var con = global.console
      var prop, method
      var dummy = function () {}
      var properties = ['memory']
      var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
        'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
        'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',')
      while (prop = properties.pop()) if (!con[prop]) con[prop] = {}
      while (method = methods.pop()) if (!con[method]) con[method] = dummy
      // Using `this` for web workers & supports Browserify / Webpack.
    })(typeof window === 'undefined' ? this : window)

    var
      ERROR_TYPE = {
        UNKNOWN: 'unknown error',
        CONSOLE_ERROR: 'console.error',
        UNCAUGHT: 'uncaught error',
        NORMAL: 'error',
        EXTERNAL: 'external script error',
        IGNORED: 'ignored error',
        RECOVERED: 'recovered error',
        REQUIREJS: 'requirejs'
      }

    var
      simpleAjax = function (opt) { // TODO: move this to an extra lib with constructor -> on init set uri
        var xhr,
          url = opt.url,
          method = opt.method || 'get',
          data = opt.data || null,
          dataStr = '',
          succCb = opt.success || function () {},
          errCb = opt.error || function () {}

        try {
          xhr = new ActiveXObject('Microsoft.XMLHTTP')   // Trying IE
        } catch (e)    // Failed, use standard object
        {
          xhr = new XMLHttpRequest()
        }

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            if (xhr.status == 200)
              succCb.apply(this, [xhr.responseText, xhr.status, xhr])
            else
              errCb.apply(this, [xhr.status, xhr])
          }
        }

        if (data) {
          var tmpVal
          for (var i in data) {
            tmpVal = data[i]
            dataStr += i + '=' + encodeURIComponent(['string', 'number'].indexOf(typeof tmpVal) > -1 ? tmpVal.toString() : JSON.stringify(tmpVal)) + '&'
          }
        }

        data = data || null

        xhr.open(method, url, true)
        if (method.toString().toLowerCase() == 'post')
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')

        try {
          xhr.send(dataStr)
        } catch (err) {

        }

      }

    var maxLenString = function(str, maxLength){
        if(!str) return
        return str.length > maxLength ? str.slice(0, maxLength) + ' ...' + (str.length - maxLength) + 'chars'  : str
      },
      simplifyVal = function (val, depth) {
        var res
        try{
          depth = depth || 0
          var
            maxLength = depth <= 4 ? 5000 : 250,
            maxDepth = 8

          // null, undefined
          if(!val) {
            return val
          }

          var valType = typeof val

          if(valType === 'function') {
            return val.toString().slice(0, 100)
          }

          if(valType === 'object') {
            if (val instanceof Error) {
              if(depth > maxDepth){
                return 'Error: ' + maxLenString(val.message, maxLength)
              }
              return {
                Error: maxLenString(val.message, maxLength),
                file: val.fileName + ':' + val.lineNumber + ':' + val.columnNumber,
                stack: maxLenString(val.stack, maxLength)
              }
            } else {
              if (val.__orig) { // is a loop
                if (Array.isArray(val)) {
                  return '<loop [' + val.__orig.toString() + ']>'
                } else { // is object
                  return '<loop {' + val.__orig.toString() + '}>'
                }

              } else {
                if (Array.isArray(val)) {
                  if (depth > maxDepth) {
                    return "[array: " + val.length + "]"
                  }

                  val.__orig = val.map(function(val) { typeof val })
                  res = val.map(function(val, i) {
                    try {
                      return simplifyVal(val, depth + 1)
                    } catch (err) {
                      return err
                    }
                  })
                } else { // is object
                  if (depth > maxDepth) {
                    return "{object: " + Object.keys(val).toString() + "]"
                  }

                  val.__orig = Object.keys(val)
                  res = Object.keys(val).reduce(function(r, k) {
                    if(k !== '__orig'){
                      r[k] = simplifyVal(val[k], depth + 1)
                    }
                    return r
                  }, {})
                }
                delete (val.__orig)
                return res
              }
            }
          }

          if(valType === 'boolean' || valType === 'symbol'){
            return val
          }

          if(valType === 'number' || valType === 'bigint'){
            return val
          }

          return maxLenString(val + '', maxLength)


        }catch(err){
          return simplifyVal(err, depth)
        }
      },
      /**
       * turns a value into a formatted string
       * @param {any} val
       * @param {number} [depth=0]
       * @param {boolean} [valIsSimplified=false]
       * @returns {string}
       */
      objToStr = function (val, depth, valIsSimplified) {
        depth = depth || 0

        var _val = valIsSimplified ? val : simplifyVal(val)

        var depthStr = function (offset) {
          var i = (offset || 0) - 1, str = ''
          while (i < depth) {
            i++
            str += '  '
          }
          return str
        }

        if(typeof _val === 'string'){
          return '`' + _val + '`'
        }

        if(['number', 'bigint', 'boolean', 'symbol'].indexOf(typeof _val) !== -1){
          return (_val).toString()
        }

        if(!_val || typeof _val !== 'object'){
          return JSON.stringify(_val)
        }

        if(Array.isArray(_val)){
          return '[' + "\n" + depthStr()
            + _val
              .map(function(v){
                return objToStr(v, depth + 1, true)
              })
              .join(",\n" + depthStr())
            + "\n" + depthStr(1) + ']'
        }

        return '{' + "\n" + depthStr()
          + Object.keys(_val)
            .map(function(k){
              return k + ': ' + objToStr( _val[k], depth + 1, true)
            })
            .join(",\n" + depthStr())
          + "\n" + depthStr(1) + '}'
      }

    var
      hashCode = function () {
        var hash = 0, i, chr, len
        if (this.length == 0) return hash
        for (i = 0, len = this.length; i < len; i++) {
          chr = this.charCodeAt(i)
          hash = ((hash << 5) - hash) + chr
          hash |= 0 // Convert to 32bit integer
        }
        return hash
      }
    String.prototype.hashCode = hashCode

    var BigError = function (errString) {
      var template = {
          styles: '\
                            .se_bigerror{ \
                                display:none; \
                                position: fixed; top:0; left:0; \
                                width: 100%; height: 100%; \
                                z-index: 9999;\
                            }\
                            .se_bigerror_veil{ \
                                display: flex; \
                                position: absolute; \
                                top: 0; left: 0; bottom: 0; right: 0; \
                                background: rgba(0,0,0,.5); \
                                justify-content: center; \
                                align-items: center; \
                            }\
                            .se_bigerror_veil > div{\
                                border-radius: 4px;\
                                box-shadow: 0 1px 3px rgba(0,0,0,.3);\
                                color: #333;\
                                width: 600px;\
                                max-width: 80%;\
                                background: #f8fafb;;\
                                padding: 2em;\
                            }\
                            .se_bigerror textarea{\
                                display: block;\
                                min-height: 5em;\
                                width: 100%; \
                                padding: 1em; \
                                margin: .5em 0;\
                                color: black; \
                            }\
                        ',
          popup: '\
                    <div class="se_bigerror">\
                        <div class="se_bigerror_veil">\
                            <div>\
                                <h1>An error occured</h1>\
                                <p>Something went wrong.</p>\
                                \
                                <p>Please forward the following information to <a href="mailto:support@surveyengine.com">support@surveyengine.com</a>.</p>\
                                \
                                <textarea class="form-control code-input-small" style="min-height: 60vh;" id="se_be_input"></textarea>\
                                <hr/>\
                                <div class="text-right">\
                                    <button class="btn btn-default btn-close">Close</button>\
                                </div>\
                            </div>\
                        </div>\
                    </div>',
        },
        nodeError,
        d = document,
        dc = function () {
          return d.createElement.apply(d, arguments)
        }

      function BigError (errString) {
        nodeError = SE.error && SE.error.node
        if (!nodeError) {
          var sdom = dc('div'), veilNode, btnCloseNode
          sdom.innerHTML = '<style>' + template.styles + '</style>' + template.popup
          d.body.appendChild(sdom)

          nodeError = d.querySelector('.se_bigerror')
          veilNode = nodeError.querySelector('.se_bigerror_veil')
          btnCloseNode = nodeError.querySelector('.btn-close')

          veilNode.addEventListener('click', function (ev) {
            if (ev.target === veilNode) hide()
          })
          btnCloseNode.addEventListener('click', hide)

          nodeError.bigError = this
          SE.error = nodeError

          SE.error = {
            show: show,
            hide: hide,
            createButtonHtml: createButtonHtml,
            node: nodeError
          }
        }

        var nodeErrorInput = nodeError.querySelector('#se_be_input')
        nodeErrorInput.value = errString

        return SE.error
      }

      function createButtonHtml (label, attributes) {
        var sdom = dc('div'),
          nodeButton = dc('button')

        attributes = attributes || {}
        attributes.onclick = 'javascript: SE.error.show();'

        Object.keys(attributes).map(function (attr) {
          nodeButton.setAttribute(attr, attributes[attr])
        })

        nodeButton.innerHTML = label
        sdom.appendChild(nodeButton)

        return sdom.innerHTML
      }

      function show () {
        nodeError.style.display = 'block'
      }

      function hide () {
        nodeError.style.display = 'none'
      }

      return BigError(errString)
    }

    /**
     * depending on IS_DEBUG and LOG_DEBUG
     * @returns {SeLoggingInst}
     * @constructor
     */
    var SeLogging = function () {

      var _this = this,
        _v = {
          events: {
            'error': {}
          },
          logs: [],
          ui: {
            optionsBigTopRight: {
              'closeButton': true,
              'preventDuplicates': true,
              'timeOut': '-1',
              'extendedTimeOut': '-1',
              'positionClass': 'toast-top-right'
            }
          },
          randomCodeBlocks: [
            ['huge', 'tiny', 'happy', 'sad', 'funny', 'drunk', 'intelligent', 'invisible', 'shiny', ''],
            ['amber', 'blue', 'cyan', 'golden', 'indigo', 'jasmin', 'mint', 'nyan', 'purple', 'red', 'yellow'],
            ['apes', 'donkeys', 'elefants', 'fishes', 'horses', 'pandas', 'sharks', 'tigers', 'wolves', 'zebras'],
            ['are'],
            ['shouting', 'running', 'jougling', 'dancing', 'flying', 'singing', 'jumping'],
            ['on', 'in', 'under', 'around'],
            ['the'],
            ['house', 'boat', 'tree', 'table', 'plane', 'street', 'river', 'car', 'spaceship', 'submarine']
          ],
          alphanumericCodeBlocks: 'ABDEFGHKLMNPQRSTUVWXY23456789',
          hexCodeBlock: '0123456789ABCDEF',

          seLogInfo: {}
        },
        _fn = {
          utils: {
            reloadPage: function () {

              var location = window.location,
                query = location.search || '?',
                uri

              // prevent the reload of death

              //TODO: replace with cookie to alert on recurring errors
              //if (query.match(/is_reload=3/)) {
              //    uri = window.location.pathname + query
              //
              //}
              //if (query.match(/is_reload=2/)) {
              //    query = "?is_reload=3";
              //    uri = window.location.pathname + query
              //
              //} else if (query.match(/is_reload=1/)) {
              //    query = query.replace("is_reload=1", "is_reload=2");
              //    uri = window.location.pathname + query
              //
              //} else {
              //    query += "&is_reload=1";
              //    uri = window.location.pathname + query + window.location.hash
              //}

              uri = location.pathname + location.search

              setTimeout(function () {
                if (location.replace) {
                  location.replace(uri)
                } else {
                  location.href = uri
                }
              }, 100)

            },
            createRandomErrorCodeFun: function () {

              var codeblocks = _v.randomCodeBlocks,
                randomErrorCode = [(Math.round(Math.random() * 89) + 10)]

              for (var i in codeblocks) {
                randomErrorCode.push(codeblocks[i][Math.round(Math.random() * (codeblocks[i].length - 1))])
              }

              return randomErrorCode.join(' ')
            },
            createRandomErrorCode: function () {

              var codelength = 5,
                codeblock = _v.alphanumericCodeBlocks,
                randomErrorCode = []

              for (var i = 0; i < codelength; i++) {
                randomErrorCode.push(codeblock[Math.round(Math.random() * (codeblock.length - 1))])
              }

              return randomErrorCode.join('')
            },
            createHexErrorCode: function (str, codelength) {
              if (!str) str = '00000000'

              while (str.length < 32) {
                str += '; ' + str
              }

              var codelength = codelength || 5,
                hexBlock = _v.hexCodeBlock,
                hashCode = str.hashCode(), // generates a 9char+ hashcode
                tmpCode,
                randomErrorCode = [] // not so random

              if (hashCode < 0) hashCode = hashCode * -1

              for (var i = 0; i < codelength; i++) {
                tmpCode = (hashCode % 16)
                randomErrorCode.push(hexBlock[tmpCode])
                hashCode = Math.round(hashCode / 10)
              }

              return randomErrorCode.join('')
            },
            /**
             * creates hex error code string based on message, the screen name or current url, the host and the commmit hash
             * @param errorMessage
             * @returns {string}    [5 char error hex]-[3 char location hex]-[2 char host hex]-[6 char commit short]
             */
            createErrorCode: function (errorMessage) {

              var screenName = location.href.match(/[^-_a-z]screen=([-_a-z]+)/i),
                code =
                  _fn.utils.createHexErrorCode(errorMessage, 5) + '-' +
                  _fn.utils.createHexErrorCode(screenName ? screenName[1] : location.pathname + location.search, 3) + '-' +
                  _fn.utils.createHexErrorCode(location.host, 2) + '-' +
                  (SE.COMMIT_HASH ? SE.COMMIT_HASH.substr(0, 6) : '000000')

              return code

            },
            argsToArray: function (orig_args) {
              var args = []

              if (!orig_args ||
                !orig_args.length)
                return args

              for (var i = 0; i < orig_args.length; i++) {
                args.push(orig_args[i])
              }
              return args
            },
            createError: function (errorMessage, params) {
              var tmpErr = new Error(errorMessage)

              tmpErr.stack = _fn.utils.getStack()

              for (var key in params) {
                var param = params[key]
                tmpErr[key] = param
              }

              return tmpErr

            },
            getStack: function (asString, fromError) {

              var stack = [],
                fullstack = [],
                newErr = new Error()

              if (newErr && newErr.stack) {
                newErr.stack.trim().split('\n').map(function (val) {

                  val = val.replace(new RegExp(window.location.origin, 'g'), '')
                  if (val.trim) val = val.trim()

                  fullstack.push(val)
                  if (val.match(/(helper\/logging\.se|getStack|wrapConsole|handleError)/)) return // ignore stack lines from within this file

                  stack.push(val)
                })
              }

              if (stack.length && stack[0].match(/error/i)) stack.shift()

              if (!stack.length) { // if there was nothing left in stack -> seems to be an issue in logging
                stack = fullstack
              }

              if (asString)
                return stack.join('\n').trim()

              return stack

            }
          },
          fire: function (eventType, args) {
            for (var i in _v.events[eventType]) {
              (_v.events[eventType][i]).apply(_this, args)
            }
          },
          setup: {
            logInfo: function () {

              var logInfo = {
                se_client_name: ENV.client_name || (ENV.assets_uri ? ENV.assets_uri.match(/clients\/([^/]+)/)[1] : undefined),
                se_survey_name: ENV.survey_name || (ENV.assets_uri ? ENV.assets_uri.match(/([^/]+)\/assets/)[1] : undefined),
                se_screen_name: ENV.screen,
                user_os: navigator.platform,
                user_browser: navigator.userAgent,
                app_ENV: ENV,
                app_version: SE.APP_VERSION + '.' + SE.COMMIT_HASH,
                app_dev: SE.IS_DEV_ENV,
                UISID: UISID
              }

              _v.seLogInfo = logInfo

            },
            setupExternalTrackers: function () {

              if (EXTERNAL_LOG_URIS) {
                window.addEventListener('beforeunload', function () {
                  _fn.api.post()
                })

              }

            },
            /**
             *
             * @param isDebug   set TRUE for DEV_ENV and TEST_ENV; console.debug and console.log are disabled
             */
            wrapConsole: function (isDebug) {
              var console_functions = ['debug', 'info', 'log', 'warn', 'error']

              console.log('!! wrapped console')
              // console wrapper
              !function (methods) {
                methods.map(function (fn) {
                  switch (fn) {
                    case 'debug':
                    case 'log':
                      if (!isDebug) {
                        console[fn] = function () {}
                        console['_' + fn] = function () {}
                        return
                      }
                      break
                  }

                  var fnOrig = console[fn]

                  // keep the orig functions for special cases.
                  if (Function.prototype.bind) {
                    console['_' + fn] = fnOrig.bind(console, '_')
                  } else {
                    console['_' + fn] = function () {
                      var args = _fn.utils.argsToArray(arguments)
                      args.unshift('_')

                      fnOrig.apply(console, args)
                    }
                  }

                  switch (fn) {
                    case 'warn':
                    case 'error':
                      break
                    default:
                      if (isDebug) {
                        // only wrap .warn and .error during DEV
                        return
                      }
                      break
                  }

                  console[fn] = function () {
                    var argArr = _fn.utils.argsToArray(arguments),
                      argArr0 = _fn.utils.argsToArray(arguments),
                      stack = _fn.utils.getStack()

                    // shorten stack
                    stack = stack.slice(0, 10)

                    if (CACHE_LOGS) {
                      _v.logs.push((new Date).toISOString() + ' | ' + fn + ' | ' + objToStr(argArr).replace(/^(.{70}).*(.{10})$/, '$1 ... $2')
                        + '\n @ ' + stack.join('\n').trim())

                      // dont keep more than the last 50 logs in memory
                      if (_v.logs.length > 50) {
                        _v.logs.shift()
                      }
                    }

                    argArr.push({
                      '@': stack
                    })

                    Function.prototype.apply.call(fnOrig, console, argArr)

                    // dispatching a console event allows us to reuse the whole functionlity where ever we need it
                    try {
                      var eventInit = {
                        detail: {
                          type: fn,       // debug, log, info, warn, error
                          details: argArr0,  // array of arguments
                          stack: stack
                        }
                      }

                      UTILS.dispatchCustomEvent(window, 'console.' + fn, eventInit)
                      UTILS.dispatchCustomEvent(window, 'console', eventInit)

                    } catch (err) {}

                  }
                })
              }(console_functions)
            },
            uncaughtErrorHandling: function () { // TODO: merge sendError functions

              console.log('!! setup error handling.')

              var
                onError = function (errEvent) { // message, source, lineno, colno, error){

                  var errObj = _fn.utils.createError(
                    errEvent.message || errEvent.description,
                    {
                      filename: errEvent.fileName || errEvent.filename,
                      line: errEvent.lineno || errEvent.lineNumber,
                      col: errEvent.colno || errEvent.columnNumber,
                      details: errEvent.error && errEvent.error.details
                    }
                  )

                  if (errEvent.error && errEvent.error.stack) {
                    errObj.stack = errEvent.error.stack
                  }

                  errObj.type = ERROR_TYPE.UNCAUGHT

                  // // -- determine if this an internal error
                  // if(errObj.filename &&
                  //     errObj.filename.match(/scriptElement$/)){ // e.g. FF "https://dev.surveyengine[...]umber=6 line 4798 > scriptElement"
                  //
                  //     // proceed with handling
                  //
                  // }else if( // EXTERNAL error cases
                  //     !errObj.filename ||                    // no file name given -> script error in global
                  //     !errObj.filename.match(/\/(lib\/reskin|diagnostics|surveys)\//)  // filename outside lib/reskin, surveys(assets) or diagnostics --> external
                  // ){
                  //
                  //     errObj.type = ERROR_TYPE.EXTERNAL;
                  //
                  //     console.warn(LOG_LABEL, "uncaught external ERROR", errEvent, errObj);
                  //
                  // }

                  var
                    isExternalScript = errObj.filename &&
                      (!errObj.filename.match(new RegExp('//' + window.location.host, 'i'))
                        || errObj.filename.match(/diagnostics\/mock-external/i)),

                      // summernote errors are handled inside ractivejs.se.editor.js component
                      isSummernoteError = errObj.filename.match(/summernote\.se\.js/)

                  if(isSummernoteError){
                    errObj.type = ERROR_TYPE.RECOVERED // is only logged, not shown to user

                  }else if ( // EXTERNAL error cases
                    isExternalScript
                  ) {
                    errObj.type = ERROR_TYPE.EXTERNAL

                    // ECMAScript6 syntax error (e.g. in IE11 or Casper)
                    // ignore only if this is Survey Editor (not Play)
                    var
                      isNotPlayScreen = ENV.screen !== 'play_screen',
                      smallAlphaCharsParenthesisBackslashAndAccentOnly = function (str) {
                        return str && str
                          .replace(/[^a-zA-Z`)\\]+/igm, ' ')
                          .replace(/\s+/igm, ' ')
                          .toLowerCase().trim()
                      },
                      doesMatchEcmaScript6SyntaxErrorMessage = smallAlphaCharsParenthesisBackslashAndAccentOnly(errObj.message).match(new RegExp('(' + [
                        'Unexpected token \'const\'',
                        'Unexpected token \'let\'',
                        'Expected token \'\\)\'',    // arrow functions error
                        'Use of reserved word \'class\'',
                        'SyntaxError: Invalid character: \'`\'' // template strings
                      ].map(smallAlphaCharsParenthesisBackslashAndAccentOnly).join('|') + ')', 'igm'))

                  if (isNotPlayScreen && // on Play ES6 errors are not allowed to be ignored
                      doesMatchEcmaScript6SyntaxErrorMessage) {
                      errObj.type = ERROR_TYPE.IGNORED
                      errObj.note = "browser does not support ES6, e.g. IE11 or Casper"
                      console.warn(LOG_LABEL, 'uncaught external ignored ES6 error', errEvent, errObj)
                    }
                  } else if (errObj.message.match('ResizeObserver loop') && !errObj.line) {
                    // dont show redbox, handle as external error
                    errObj.type = ERROR_TYPE.IGNORED
                    errObj.note = "summernote issue - not solvable but ignoreable"
                  } else if (errObj.message.match('Script error\.') && !errObj.line) {
                    // dont show redbox
                    errObj.type = ERROR_TYPE.IGNORED
                    errObj.note = "script error in an external script (missing details and error line); maybe a browser plugin"
                  } else if(errObj.message.match(/Permission denied to access property/i)){
                    // dont show redbox
                    errObj.type = ERROR_TYPE.IGNORED
                    errObj.note = "happens mostly when summernote is initialized; issue is with jQuery"
                  }

                  _fn.handleError(errObj)

                }

              // uncaught error handling -> send to logger
              window.addEventListener('error', onError)
              document.addEventListener('error', onError)

            },
            wrappedLogHandling: function () {

              var onWrappedLog = function (ev) { // {type, details}
                var logInfo = ev.detail
                /*
                 logInfo = {
                     type: fn,       // debug, log, info, warn, error
                     details: argArr0,  // array of arguments
                     stack: stack
                 }
                 */

                if (logInfo.type == 'error') {

                  var isApiError =
                    logInfo.type == 'error' &&
                    logInfo.details &&
                    logInfo.details.length >= 2 &&
                    logInfo.details[1].xhr &&
                    logInfo.details[1].xhr.responseText

                  var errorMessage,
                    errorUri

                  if (isApiError) {
                    // special treatment for API_SRV query errors
                    /*
                     {
                     "type":"error",
                     "data": [
                     "API SRV",
                     {
                     "log":"query erroR: Bad Request",
                     "url":"http://stage.surveyengine.com/bin/ui.pl?screen=edit_page_screen&survey_name=Ticket_278&_=1469786481983&survey_name=Ticket_278&op=xml_load_index",
                     "data":"Bad Request",
                     "status":"error",
                     "xhr":{
                     "readyState":4,
                     "responseText":"<!DOCTYPE HTML PUBLIC \"-//IETF//DTD HTML 2.0//EN\">\n<html><head>\n<title>400 Bad Request</title>\n</head><body>\n<h1>Bad
                     Request</h1>\n<p>Your browser sent a request that this server could not understand.<br />\n</p>\n</body></html>\n",
                     "status":400,
                     "statusText":"Bad Request"
                     }
                     }
                     ]
                     }
                     */

                    errorMessage = [
                      logInfo.details[1].xhr.responseText,
                      logInfo.details[1].xhr.statusText + ' ' +
                      logInfo.details[1].xhr.status
                    ].join('\n')
                    errorUri = logInfo.details[1].url

                  } else {
                    errorMessage = ''
                    while (typeof logInfo.details[0] == 'string') {
                      errorMessage += logInfo.details.shift() + '; '
                    }

                    errorMessage = errorMessage.trim()
                  }

                  var
                    errObj = _fn.utils.createError(errorMessage, {
                      type: ERROR_TYPE.CONSOLE_ERROR,
                      uri: errorUri,
                      details: logInfo.details
                    })

                  _fn.handleError(errObj)

                } else {

                  _fn.api.sendWrappedConsoleLog('console.' + logInfo.type, logInfo)

                }

              }

              //window.addEventListener("console.warn",     onWrappedLog);
              window.addEventListener(ERROR_TYPE.CONSOLE_ERROR, onWrappedLog)

            }
          },
          handleError: function (errorObj) {

            // ignore errors on page-unload
            if (PAGE_IS_UNLOADING) {
              console._error(LOG_LABEL, 'ignoring error on page-unload', errorObj)
              return
            }

            var reportToUser = true,
              defaultErrorMessage = 'unknown',
              errDataObj

            if (!errorObj) {
              errorObj = _fn.utils.createError(defaultErrorMessage, {
                type: ERROR_TYPE.UNKNOWN
              })
            }

            if (!errorObj.message) {
              errorObj.message = defaultErrorMessage
            }

            if (!errorObj.stack) {
              errorObj.stack = _fn.utils.getStack()
            }

            errDataObj = {
              time: (new Date()).toISOString(),
              type: errorObj.type,
              code: _fn.utils.createErrorCode(errorObj.message),
              message: errorObj.message,
              info: {
                details: errorObj.details,
                link: errorObj.uri || window.location.href,
                source: errorObj.filename,
                line: errorObj.line || errorObj.lineno || '',
                col: errorObj.col || errorObj.colno || '',
                stack: errorObj.stack,
                // env: _v.seLogInfo,
                logs: _v.logs.slice(-10).reverse()
              }
            }

            // -- send error log

            _fn.api.sendError(errDataObj)

            if (errDataObj.type === ERROR_TYPE.IGNORED) {

              console._error(LOG_LABEL, 'logged ignored uncaught error: ', errDataObj.message, errDataObj)

            } else if (errDataObj.type === ERROR_TYPE.RECOVERED) {

              console._error(LOG_LABEL, 'logged recovered uncaught error: ', errDataObj.message, errDataObj)

            } else {

              // -- show toasty

              var stackStr = JSON.stringify(errorObj.stack)

              var errStr = objToStr(errDataObj),
                copyBtnHtmlStr = copy.createCopyThisButton([
                  'LINK: ' + errDataObj.info.link,
                  '',
                  'ERROR',
                  objToStr(errDataObj)
                ].join('\n'), {
                  class: 'btn btn-sm btn-outline btn-default',
                  title: 'Copy error to clipboard'
                }),
                bigError = new BigError(errStr),
                bigErrorBtnHtmlStr = bigError.createButtonHtml('Details', { class: 'btn btn-sm btn-outline btn-default' })

              //console._info("ERR", [err, errorMessage]);

              // TODO - move this error code to some external string lib
              if (maxNrOfErrorToastiesToShow > 0) {
                maxNrOfErrorToastiesToShow--
                toasties.error(
                  'Error #' + errDataObj.code + '  has occurred on this page. <br/> Click \'reload\' below to continue.',
                  [
                    'For further information click ',
                    bigErrorBtnHtmlStr
                    // ,
                    // 'If the problem persists please ' +
                    // '<a href="mailto:support@surveyengine.com?subject=Support Request: Code #' + errDataObj.code + '">' +
                    // 'contact "support@surveyengine.com" with the ' +
                    // 'SupportCode: #' + errDataObj.code + '' +
                    // '</a>',
                    // copyBtnHtmlStr
                  ],
                  'Reload page',
                  _fn.utils.reloadPage,
                  {
                    onHidden: function () {
                      maxNrOfErrorToastiesToShow++
                    }
                  }
                )
              }

              // -- fire error event

              _fn.fire('error', [errDataObj])
            }

          },
          api: {

            sendLog: function (/*...*/) {
              var logArr = [],
                logStr = '',
                val
              for (var i in arguments) {
                val = arguments[i]
                // logArr.push(typeof val === 'object' ? objToStr(val) : val + '')
                logArr.push(simplifyVal(val))
              }

              var logData = {
                text: logArr[0],
                tag: 'debug',
                details: {
                  code: _fn.utils.createHexErrorCode(logArr[0]),
                  time: (new Date()).toISOString(),
                  data: logArr,
                  info: {
                    stack: _fn.utils.getStack(true),
                    // env: _v.seLogInfo,
                  }
                }
              }

              this.send(logData)

            },
            /**
             * @param errDataObj  = {
                                code: randomErrorCode, *
                                message: err.message, *
                                source: err.filename, *
                                line: err.line,
                                col: err.col,
                                error: err.error,
                                logs: _v.logs.slice(-20).reverse()
                            };
             */
            sendError: function (errDataObj) {

              var logData = {
                text: errDataObj.message,
                tag: 'error',
                details: errDataObj
              }

              this.send(logData)
            },
            /**
             * @param {('console.debug'|'console.log'|'console.info'|'console.warn'|'console.error')} type
             * @param {any} data
             */
            sendWrappedConsoleLog: function (type, data) {

              var typeTagsMap = {
                'console.debug': 'debug',
                'console.log': 'notice',
                'console.info': 'info',
                'console.warn': 'warning',
                'console.error': 'error'
              }

              var logData = {
                text: type,
                tag: typeTagsMap[type] || 'debug',
                details: {
                  code: type.split('.').splice(-1), //
                  arguments: data
                }
              }

              this.send(logData)

            },
            sendNote: function (errorCode, noteStr) {

              var logData = {
                text: errorCode + ': ' + noteStr,
                tag: 'notice',
                details: {
                  code: errorCode,
                  note: noteStr
                }
              }

              this.send(logData)

            },
            /**
             * does not actually send the data but queues it and triggers the sending of the logs
             * @param logData
             */
            send: function (logData) {

              if (EXTERNAL_LOG_URIS) {

                // check if log with this error code was already queued
                try {
                  var randomErrorCode = logData.details.code,
                    sentLogTimestamp = sentLogIds[randomErrorCode]

                  if (!sentLogTimestamp || // if not set yet
                    sentLogTimestamp + EXTERNAL_LOG_RESEND_LOG_DELAY_MS < Date.now()) { // or older than e.g. 10sec
                    sentLogIds[randomErrorCode] = Date.now()

                  } else { // otherwise it was already sent within e.g. the last 10sec -> dont log again
                    return
                  }

                } catch (err) {
                  // most likely logData.details.data.code did not exist .. who cares. lets queue it anyway
                }

                var
                  location = window.location.href,
                  tag = logData.tag || 'debug'

                delete(logData.tag)

                externalLogQueue.push({
                  datetime: (new Date()).toISOString(),
                  env: _v.seLogInfo,
                  location: location,
                  tag: tag,
                  log: logData
                })

                _fn.api.post()

              }
            },
            /**
             * causes all queued log to be pushed to the external logger
             */
            post: function () {
              if (EXTERNAL_LOG_URIS) {        /* only log if configured by server */

                if (externalLogQueue.length === 0) return
                if (state_isLoggingToExternalLog) {

                  return setTimeout(function () {
                    _fn.api.post()
                  }, 100) // simply retry.

                }
                state_isLoggingToExternalLog = true

                var logObj = externalLogQueue.splice(0)

                try {
                  //window._LTracker.push(logData);

                  EXTERNAL_LOG_URIS.map(function(uri){
                    simpleAjax({
                      url: uri,
                      method: 'post',
                      data: {
                        data: logObj
                      },
                      success: function succCb () {
                        state_isLoggingToExternalLog = false
                        console._log(LOG_LABEL, 'logged to ' + uri)
                      },
                      error: function errCb () {
                        state_isLoggingToExternalLog = false
                        console._warn(uri + ' log not written')
                      }
                    })
                  })

                } catch (err) {
                  state_isLoggingToExternalLog = false
                  console._error('Send log FAILED', '?!!?', err)
                }
              }
            }
          },
          init: function () {
            //if (!window.LOG_DEBUG && !window.IS_DEBUG) return;

            _fn.setup.logInfo()

            _fn.setup.uncaughtErrorHandling() // red-box on error

            _fn.setup.wrapConsole(DEBUG_MODE)
            _fn.setup.setupExternalTrackers()
            _fn.setup.wrappedLogHandling() // dependent of wrapConsole

          }

        },
        fn = {
          ERROR_TYPE: ERROR_TYPE,
          remoteLog: function (/*.. args*/) {

            _fn.api.sendLog.apply(_fn.api, arguments)

          },
          error: function (errorMessageObj, params) {
            var errObj

            if (typeof errorMessageObj === 'object' && typeof params === 'undefined') {
              errObj = errorMessageObj
              errObj.type = errObj.type || 'logging.error'

            } else {
              params = params || {}
              params.type = params.type || 'logging.error'

              errObj = _fn.utils.createError(errorMessageObj, params)
            }

            _fn.handleError(errObj)

          },
          /**
           * @type SeLToastyFn
           */
          error_plain: function (title, message, buttonLabel, callbackFn, options) {
            options = options || {}

            if (!message) {
              message = title
              title = 'ERROR'
            }

            if (maxNrOfErrorToastiesToShow > 0) {
              maxNrOfErrorToastiesToShow--

              var optOnHidden = options.onHidden || function () {}
              options.onHidden = function () {
                maxNrOfErrorToastiesToShow++
                optOnHidden()
              }

              return toasties.error(title, message, buttonLabel || 'Dismiss', callbackFn, options)
            }

          },
          warn: function (title, message, buttonLabel, callbackFn, options) {
            if (!message) {
              message = title
              title = 'WARNING'
            }
            return toasties.warn(title, message, buttonLabel || 'Dismiss', callbackFn, options)

          },
          success: function (title, message, buttonLabel, callbackFn, options) {
            if (!message) {
              message = title
              title = 'SUCCESS'
            }
            return toasties.success(title, message, buttonLabel || 'Dismiss', callbackFn, options)

          },

          dismissAll: function () {
            toasties.clear()
          },
          tryReloadingPage: function (delayReloadMs) {

            if (reloadedStatus.reloadAllowed()) {
              setTimeout(function () {
                reloadedStatus.saveReload()
                _fn.utils.reloadPage()
              }, delayReloadMs || 1500)

              return true
            }

            return false

          },
          on: function (eventType, callbackFn) {

            _v.events[eventType] = _v.events[eventType] || []
            _v.events[eventType][callbackFn] = callbackFn

          },
          off: function (evenType, callbackFn) {
            if (_v.events[eventType])
              delete (_v.events[eventType][callbackFn])
          },
          setInfo: function (obj) {
            if (!obj || typeof obj !== 'object') return

            for (var i in obj) {
              _v.seLogInfo[i] = obj[i]
            }
          }
        }

      _fn.init()

      for (var i in fn) {
        this[i] = fn[i]
      }

      return this
    }

    /**
     * @type {SeLoggingInst}
     */
    var seLogging = new SeLogging()

    if (EXTERNAL_LOG_URIS) {
      SE.LOGGING_ACTIVE = true
    } else {
      SE.LOGGING_ACTIVE = false
    }

    SE.logging = seLogging
    SE.LOGGING_INITIALIZED = true

    return seLogging
  }
)
;
